import { render } from "./ScDataTable.vue?vue&type=template&id=62793e18"
import script from "./ScDataTable.vue?vue&type=script&lang=js"
export * from "./ScDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTable2/ScDataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62793e18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62793e18', __exports__)) {
    console.log('reload')
    api.reload('62793e18', __exports__)
  }
  
  module.hot.accept("./ScDataTable.vue?vue&type=template&id=62793e18", () => {
    console.log('re-render')
    api.rerender('62793e18', render)
  })

}


export default __exports__